var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLoginlayout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 504,
    viewBox: "0 0 768 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10264_42426",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -264,
    width: 768,
    height: 768
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    transform: "translate(0 -264)",
    fill: "url(#paint0_radial_10264_42426)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10264_42426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10264_42426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10264_42426)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -264,
    x2: 0.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: -264,
    x2: 48.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: -264,
    x2: 96.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: -264,
    x2: 144.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    y1: -264,
    x2: 192.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    y1: -264,
    x2: 240.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    y1: -264,
    x2: 288.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.5,
    y1: -264,
    x2: 336.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.5,
    y1: -264,
    x2: 384.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.5,
    y1: -264,
    x2: 432.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.5,
    y1: -264,
    x2: 480.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.5,
    y1: -264,
    x2: 528.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.5,
    y1: -264,
    x2: 576.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.5,
    y1: -264,
    x2: 624.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.5,
    y1: -264,
    x2: 672.5,
    y2: 504,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720.5,
    y1: -264,
    x2: 720.5,
    y2: 504,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -263.5,
    width: 767,
    height: 767,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10264_42426)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 23.5,
    x2: 768,
    y2: 23.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 71.5,
    x2: 768,
    y2: 71.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 119.5,
    x2: 768,
    y2: 119.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 167.5,
    x2: 768,
    y2: 167.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 215.5,
    x2: 768,
    y2: 215.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 263.5,
    x2: 768,
    y2: 263.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 311.5,
    x2: 768,
    y2: 311.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 359.5,
    x2: 768,
    y2: 359.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 407.5,
    x2: 768,
    y2: 407.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 455.5,
    x2: 768,
    y2: 455.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 503.5,
    x2: 768,
    y2: 503.5,
    stroke: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -263.5,
    width: 767,
    height: 767,
    stroke: "#E4E7EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10264_42426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(384 384) rotate(90) scale(384 384)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10264_42426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white",
    transform: "translate(0 -264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10264_42426"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -264,
    width: 768,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10264_42426"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -264,
    width: 768,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginlayout);
export default __webpack_public_path__ + "static/media/Bg_loginlayout.15ed4c9856668f830f623c4db7164b84.svg";
export { ForwardRef as ReactComponent };